/**
 * Brand configuration - matches the logo "Kebabs to go!"
 * Use BRAND_NAME for display text; DOMAIN for email/URLs (no spaces allowed)
 */
export const BRAND_NAME = "Kebabs to go!";
export const BRAND_DOMAIN = "kebabstogo.com";
export const LOGO_URL =
  "https://storage.googleapis.com/happyspace-preview-projects/uploads/projects/63f01a99-fc22-4be1-b78a-e05e714375f2/1770286635621-ots1ae.png";
